import React from 'react';

// The corporate design writes the letters "AI" of pAIoneer in magenta, in the
// company name as well as in its mail address and domain. Texts stay plain
// strings in the language files; this marks the letters where they are shown.
const brandName = /(p(?:AI|ai)oneer)/;

export const brandText = (text) => {
  if (typeof text !== 'string' || !brandName.test(text)) {
    return text;
  }

  return text.split(brandName).map((part, index) => (
    index % 2 === 1
      ? <React.Fragment key={index}>{part[0]}<span className="brand-ai">{part.slice(1, 3)}</span>{part.slice(3)}</React.Fragment>
      : part
  ));
};

const BrandText = ({ children }) => <>{brandText(children)}</>;

export default BrandText;
